// src/config.ts
interface Config {
  centralApiBaseUrl: string;
  centralFrontBaseUrl: string,
  gitApiBaseUrl: string;
}

const hostname = window.location.hostname;
const hostport = window.location.port;

const apiBaseUrl = (() => {
  let apiUrl = '';
  if (hostname === "127.0.0.1" || hostname === "localhost") {
    // Case 1: Localhost, use port 5050
    apiUrl = `http://127.0.0.1:5050`;
  } else if (/^[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+$/.test(hostname) && hostport) {
    // Case 2: If it's an IP address with port, use port 5050
    apiUrl = `http://${hostname}:5050`;
  } else if (/^[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+$/.test(hostname)) {
    // Case 3: If it's an IP address, use /api
    apiUrl = `https://${hostname}/api`;
  } else if (hostport !== "") {
    // Case 4: If it's not an ip but there is a port, append '/api' to the hostname + port
    apiUrl = `https://${hostname}:${hostport}/api`;
  } else {
    // Case 5: Otherwise, append '/api' to the hostname
    apiUrl = `https://${hostname}/api`;
  }
  
  return apiUrl;
})();

const frontBaseUrl = (() => {
  let frontUrl = '';
  if (hostname === "127.0.0.1" || hostname === "localhost") {
    // Case 1: Localhost, use port 3000
    frontUrl = `http://127.0.0.1:3000`;
  } else if (/^[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+$/.test(hostname) && hostport) {
    // Case 2: If it's an IP address with port, use port 3000
    frontUrl = `http://${hostname}:3000`;
  } else if (/^[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+$/.test(hostname)) {
    // Case 3: If it's an IP address, use hostname
    frontUrl = `https://${hostname}`;
  } else if (hostport !== "") {
    // Case 4: If it's not an ip but there is a port, append '/api' to the hostname + port
    frontUrl = `https://${hostname}:${hostport}`;
  } else {
    // Case 5: Otherwise, append '/api' to the hostname
    frontUrl = `https://${hostname}`;
  }
  return frontUrl;
})();


const config: Config = {
  centralApiBaseUrl: apiBaseUrl,
  centralFrontBaseUrl: frontBaseUrl,
  gitApiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://git.tools.dev.hobud.eu/api/v4'
};

export default config;
